import {
  AlignmentType,
  Document,
  Packer,
  Table,
  WidthType,
  PageNumber,
  Paragraph,
  Footer,
  TextRun,
  NumberFormat,
  convertMillimetersToTwip,
} from "docx";
import generateLvTableHeadRow from "./generateLvTableHeadRow";
import generateMicropilesRow from "./generateMicropilesRow";
import generatePileheadsRow from "./generatePileheadsRow";
import generateConstructionSiteSetupRow from "./generateConstructionSiteSetupRow";
import generateTestLoadsRow from "./generateTestLoadsRow";
import generateRequirementsRows from "./generateRequirementsRows";

export default async function generateDocx(lvData, options) {
  const header = new Paragraph({
    children: [
      new TextRun({
        text: "Vorschlag LV-Text",
        bold: true,
      }),
      new TextRun({
        text: "BV:\t" + lvData.title,
        bold: true,
        break: 1,
      }),
      new TextRun({
        text: "\t" + lvData.subtitle,
        bold: true,
        break: 1,
      }),
      new TextRun({
        text: "",
        break: 2,
      }),
    ],
  });

  const includePositionConstructionSiteSetup = options.find(
    (option) => option.name === "optionConstructionSiteSetup"
  ).value;
  const includePositionMicropiles = options.find(
    (option) => option.name === "optionMicropiles"
  ).value;
  const includePositionPileheads = options.find(
    (option) => option.name === "optionPileheads"
  ).value;
  const includePositionTestLoads = options.find(
    (option) => option.name === "optionTestLoads"
  ).value;
  const includePositionRequirements = options.find(
    (option) => option.name === "optionRequirementItems"
  ).value;

  let lvTableRows = [];
  lvTableRows.push(generateLvTableHeadRow());

  let positionNumber = 10;

  if (includePositionConstructionSiteSetup) {
    lvTableRows.push(generateConstructionSiteSetupRow(positionNumber));
    positionNumber += 10;
  }
  if (includePositionMicropiles) {
    lvTableRows.push(generateMicropilesRow(lvData, positionNumber));
    positionNumber += 10;
  }
  if (includePositionPileheads) {
    lvTableRows.push(generatePileheadsRow(lvData, positionNumber));
    positionNumber += 10;
  }
  if (includePositionTestLoads) {
    lvTableRows.push(generateTestLoadsRow(lvData, positionNumber));
    positionNumber += 10;
  }
  if (includePositionRequirements) {
    lvTableRows = lvTableRows.concat(generateRequirementsRows(lvData, positionNumber));
  }
  const lvTable = new Table({
    rows: lvTableRows,
    width: {
      size: 100,
      type: WidthType.AUTO,
    },
    columnWidths: [
      convertMillimetersToTwip(12),
      convertMillimetersToTwip(96),
      convertMillimetersToTwip(16),
      convertMillimetersToTwip(12),
      convertMillimetersToTwip(12),
      convertMillimetersToTwip(12),
    ],
  });

  const formattedDate = new Date().toLocaleDateString("de-DE");

  const docx = new Document({
    sections: [
      {
        properties: {
          page: {
            pageNumber: {
              start: 1,
              formatType: NumberFormat.DECIMAL,
            },
          },
        },
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    children: [formattedDate],
                  }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.RIGHT,
                children: [
                  new TextRun({
                    children: ["Seite ", PageNumber.CURRENT],
                  }),
                  new TextRun({
                    children: ["/", PageNumber.TOTAL_PAGES],
                  }),
                ],
              }),
            ],
          }),
        },
        children: [header, lvTable],
      },
    ],
  });

  return Packer.toBlob(docx).then((blob) => {
    return blob;
  });
}
